<template>
  <div class="socList">
    <p class="selectAll">
      <el-checkbox
        v-model="allChecked"
        @change="handleAllCheckedChange">
        Seleccionar todos
        <span>{{ checkedSummary }}</span>
      </el-checkbox>
    </p>
    <div class="sectionContainer">
      <el-checkbox-group
        v-model="checked" style="overflow: hidden">
        <el-checkbox
          :class="item | optionColor"
          :label="item.suborder"
          :disabled="!item.verified"
          :key="item.suborder"
          v-for="item in filteredData">
          <soc-item :data="item" @remove="removeSoc" />
        </el-checkbox>
      </el-checkbox-group>
    </div>
  </div>
</template>

<script>
import ElCheckbox from 'element-ui/packages/checkbox';
import ElCheckboxGroup from 'element-ui/packages/checkbox-group';
import SocItem from './selector/SocItem.vue';

export default {
  name: 'SocSelector',
  components: {
    SocItem,
    ElCheckbox,
    ElCheckboxGroup,
  },
  props: {
    data: {
      type: Array,
      default() {
        return [];
      },
    },
    format: {
      type: Object,
      default() {
        return {};
      },
    },
    filterMethod: Function,
    props: {
      type: Object,
      default() {
        return {
          label: 'label',
          key: 'key',
          disabled: 'disabled',
        };
      },
    },
  },
  data() {
    return {
      checked: [],
      allChecked: false,
      query: '',
      inputHover: false,
      checkChangeByUser: true,
    };
  },
  watch: {
    checked(val, oldVal) {
      this.updateAllChecked();
      if (this.checkChangeByUser) {
        const movedKeys = val.concat(oldVal)
          .filter(v => val.indexOf(v) === -1 || oldVal.indexOf(v) === -1);
        this.$emit('checked-change', val, movedKeys);
      } else {
        this.$emit('checked-change', val);
        this.checkChangeByUser = true;
      }
      this.$emit('input', val);
    },
    data() {
      const checked = [];
      const filteredDataKeys = this.filteredData.map(item => item.suborder);
      this.checked.forEach((item) => {
        if (filteredDataKeys.indexOf(item) > -1) {
          checked.push(item);
        }
      });
      this.checkChangeByUser = false;
      this.checked = checked;
    },
    checkableData() {
      this.updateAllChecked();
    },
    filteredData() {
      this.checked = [];
    },
  },
  computed: {
    checkedSummary() {
      const checkedLength = this.checked.length;
      const dataLength = this.data.length;
      const { noChecked, hasChecked } = this.format;
      if (noChecked && hasChecked) {
        return checkedLength > 0
          ? hasChecked.replace(/\${checked}/g, checkedLength).replace(/\${total}/g, dataLength)
          : noChecked.replace(/\${total}/g, dataLength);
      }
      return `${checkedLength}/${dataLength}`;
    },
    checkableData() {
      return this.filteredData.filter(item => item.verified);
    },
    filteredData() {
      return this.data.filter((item) => {
        if (typeof this.filterMethod === 'function') {
          return this.filterMethod(item);
        }
        return true;
      });
    },
  },
  filters: {
    optionColor(soc) {
      // eslint-disable-next-line no-nested-ternary
      return !soc.verified ? 'el-transfer-panel__item unverified'
        : soc.dp_id === 0 || soc.last_state === 5 || soc.last_state === 6 ? 'el-transfer-panel__item nonruteable'
          : 'el-transfer-panel__item selectable';
    },
  },
  methods: {
    removeSoc(soc) {
      this.$emit('removeSoc', soc);
    },
    updateAllChecked() {
      const checkableDataKeys = this.checkableData.map(item => item.suborder);
      this.allChecked = checkableDataKeys.length > 0
        && checkableDataKeys.every(item => this.checked.indexOf(item) > -1);
    },
    handleAllCheckedChange(value) {
      this.checked = value
        ? this.checkableData.map(item => item.suborder)
        : [];
    },
  },
};
</script>

<style scoped>
  ul {
    max-height: 240px;
    min-height: 100px;
    overflow-y: scroll;
    overflow-x: hidden;
    border: 1px solid #EBEEF5;
    padding-left: 10px;
  }
  li {
    font-family: "Lato", sans-serif;
    height: 30px;
    font-size: 14px;
    width: 95%;
    list-style-type: none;
    border-bottom: 1px solid #EBEEF5;
  }
  .el-checkbox {
    width: 100%;
    margin-bottom: -1px;
  }
  .unverified {
    background: rgba(233,212,41,0.09);
    border-bottom: solid 1px #EAEAEA;
  }
  .nonruteable{
    background: rgba(233,98,22,0.13);
    border-bottom: solid 1px #EAEAEA;
  }
  .selectable{
    border-bottom: solid 1px #EAEAEA;
  }
  .selectAll {
    margin: 10px 5px 10px 16px;
  }
  .sectionContainer {
    max-height: 240px;
    min-height: 120px;
    overflow-y: scroll;
    overflow-x: hidden;
    border: 1px solid #EBEEF5;
    padding-left: 0;
  }
</style>
